const VARIANT_CLASS = {
  default:  'tg-badge--accent',
  success:  'tg-badge--online',
  warning:  'tg-badge--warning',
  danger:   'tg-badge--danger',
  info:     'tg-badge--info',
  outline:  'tg-badge--offline',
  online:   'tg-badge--online',
  offline:  'tg-badge--offline',
  alert:    'tg-badge--danger',
}

export default function Badge({ variant = 'default', size = 'sm', dot = false, children, style }) {
  const classes = [
    'tg-badge',
    `tg-badge--${size}`,
    VARIANT_CLASS[variant] || 'tg-badge--accent'
  ].join(' ')

  return (
    <span className={classes} style={style}>
      {dot && <span className="tg-badge__dot" />}
      {children}
    </span>
  )
}
